import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide toggle. Drop-in replacement for <input type="password" />.
 * Pass any normal input prop (value, onChange, required, placeholder, autoComplete, etc.).
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { className = "", "data-testid": testId = "password-input", ...rest },
  ref
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        ref={ref}
        type={visible ? "text" : "password"}
        className={`pr-10 ${className}`}
        data-testid={testId}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? "Hide password" : "Show password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-hh-ink/50 hover:text-hh-ink transition-colors"
        data-testid={`${testId}-toggle`}
      >
        {visible ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});
